module.exports = __webpack_public_path__ + "img/avatar.f57ebce8.png";